export interface EnumDef {
    [key: string]: string;
}

export interface EnumItem<V extends PropertyKey> {
    value: V;
    display: string;
}

export interface EnumItems<V extends PropertyKey> {
    items: Array<EnumItem<V>>;
}

export type Enumified<E extends EnumDef, V extends keyof E> = E & {
    [key: string]: V;
} & EnumItems<V>;

export function enumify<E extends EnumDef, V extends keyof E>(def: E): Enumified<E, V> {
    const enumified: any = { items: [] };
    Object.keys(def).forEach((value) => {
        const display = def[value];
        enumified[value] = display;
        enumified[display] = value;
        enumified.items.push({ value, display });
    });

    return enumified;
}
